import React from 'react';
import { Container, Box, Typography, Button, IconButton } from '@mui/material';
import { Facebook, LinkedIn, Google, Twitter, Instagram } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { BACKGROUND_COLOR, PRIMARY_COLOR } from '../colorPalette';
import { DEFAULT_FONT_FAMILY } from '../styles';
import RoundedFilledButton from '../components/RoundedFilledButton';
import GoogleIcon from '@mui/icons-material/Google';
import LocalMallOutlinedIcon from '@mui/icons-material/LocalMallOutlined';
import RoundedFilledIconButton from '../components/RoundedFilledIconButton';
import GoogleIcon2 from '../components/icons/Google.svg';
// firebase
import { GoogleAuthProvider, getAuth, signInWithPopup } from 'firebase/auth';
import { useDispatch, useSelector } from 'react-redux';
// Redux
import { setLoading} from '../redux/userSlice';
import Logo from '../components/Logo';
import AppVersion from '../components/AppVersion';

const LandingPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const loading = useSelector((state) => state.user.loading);


  // Google Auth Provider
  var provider = new GoogleAuthProvider();
  provider.setCustomParameters({
    prompt: 'select_account'
  });

  const handleGoogleSignInButtonClick = async () => {
    const auth = getAuth();
    signInWithPopup(auth, provider)
      .then((result) => {
        dispatch(setLoading(true));

        // // Set persistence based on the "Remember Me" checkbox state
        // await setPersistence(auth, rememberMe ? browserLocalPersistence : browserSessionPersistence);
        // rememberMe && console.log("Remember Me is checked. Using local persistence.");

        // This gives you a Google Access Token. You can use it to access the Google API.
        const userCredential = GoogleAuthProvider.credentialFromResult(result);
        const token = userCredential.accessToken;
        // The signed-in user info.
        const firebaseUser = result.user;
        console.log("User signed into Firebase with Google succesfully: ", firebaseUser, userCredential);
        // IdP data available using getAdditionalUserInfo(result)
        // ...
        dispatch(setLoading(false));
      }).catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.customData.email;
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
        // ...
      });
  }

  return (
    <Container maxWidth="md" style={styles.container}>
      <Box style={styles.logoContainer}>
        {/* <Typography variant="h1" style={styles.logo}>lumas.</Typography> */}
        <Logo />
      </Box>
      <Box style={styles.buttonContainer}>
        <RoundedFilledButton onClick={() => {navigate('/login')}} >Log In</RoundedFilledButton>
        <Button onClick={() => {navigate('/sign-up')}} variant="outlined" style={styles.button} >
          Create Account
        </Button>
        {/* Divider with 'or" */}
        <Box>
          <Box style={{display: 'flex', alignItems: 'center', gap: '10px', width: '100%', margin: '20px 0'}}>
            <Box style={{flex: 1, height: '1px', backgroundColor: '#D0D0D0'}}></Box>
            <Typography variant="body2" sx={{textAlign: 'center', color: 'gray'}}>OR</Typography>
            <Box style={{flex: 1, height: '1px', backgroundColor: '#D0D0D0'}}></Box>
          </Box>
        </Box>
        <RoundedFilledIconButton icon={<img src={GoogleIcon2} alt="Google" style={{width: '24px', height: '24px'}} />} onClick={() => {handleGoogleSignInButtonClick()}} >Sign in with Google</RoundedFilledIconButton>
      </Box>
      <Box style={styles.socialContainer}>
        {/* <IconButton style={styles.iconButton}>
          <Google style={styles.icon} />
        </IconButton> */}
        {/* <IconButton style={styles.iconButton}>
          <Instagram style={styles.icon} />
        </IconButton> */}
        <IconButton style={styles.iconButton} href='https://lumas.live'>
          <LocalMallOutlinedIcon style={styles.icon} />
        </IconButton>
      </Box>
      <Box style={styles.signInAnother}>
        <Typography variant="body2" style={styles.signInText}>
          Browse our product catalog!
        </Typography>
        <AppVersion />
      </Box>
    </Container>
  );
};

const styles = {
  container: {
    fontFamily: DEFAULT_FONT_FAMILY,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: window.innerHeight,
    backgroundColor: BACKGROUND_COLOR,
  },
  logoContainer: {
    marginTop: '10%',
  },
  logo: {
    fontSize: '48px',
    color: PRIMARY_COLOR,
    margin: '0',
  },
  buttonContainer: {
    marginTop: '40px',
    display: 'flex',
    flexDirection: 'column',
    gap: '25px',
  },
  button: {
    width: '250px',           // Increase button width
    height: '60px',           // Increase button height
    padding: '15px 0',        // Increase padding
    borderColor: PRIMARY_COLOR,
    color: PRIMARY_COLOR,
    borderRadius: '30px',     // Adjust the border radius as needed
    fontSize: '18px',         // Increase font size
    textTransform: 'none',    // Keep text casing as-is
  },
  filledButton: {
    backgroundColor: PRIMARY_COLOR,
    color: '#F7F7F7',
    borderRadius: '30px',
    textTransform: 'none',
    width: '250px',
    height: '60px',
    padding: '15px 0',
    fontSize: '18px',
  },
  socialContainer: {
    marginTop: 'auto',
    display: 'flex',
    justifyContent: 'center',
    gap: '15px',
    marginBottom: '10px',
  },
  iconButton: {
    color: PRIMARY_COLOR,
  },
  signInAnother: {
    marginBottom: '10%',
  },
  signInText: {
    color: '#A0A0A0',
    fontSize: '14px',
  },
  icon: {
    color: '#A0A0A0'
  }
};

export default LandingPage;